import React, { Component } from 'react';

Date.prototype.addDays = function(days) {
  var dat = new Date(this.valueOf());
  dat.setDate(dat.getDate() + days);
  return dat;
}


export function Logo(props) {
  return (
    <div id="logo">
      <h1 style={{fontSize: props.size}}>Diary</h1>
      <p>Write how do you live. Disclose it to the next generation when you die.</p>      
    </div>
  );
}

export class Button extends React.Component {
  
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <button type='button' onClick={this.props.onClick}>
      {this.props.value}
      </button>
    );
  }
}


// WEBPACK FOOTER //
// ./src/util.js